// extracted by mini-css-extract-plugin
module.exports = {"row":"FoodSidebarHoldAndRetrieveButtons_row__3FpuA"};